<template>
  <v-checkbox v-bind:value="value" @change="change" :rules="rules" required>
    <template v-slot:label>
      <div>
        <span>{{ trans('app.aggree_tos') }}</span>
        <a class="ml-1" href="/article/terms" @click.stop="linkToTerms">{{ trans('app.agree_tos_link') }}</a>
      </div>
    </template>
  </v-checkbox>
</template>
<script>
import EventBus from "../../event_bus";

export default {
  props: ["value", "rules"],

  methods: {
    change: function(value) {
      this.$emit("input", value);
    },

    linkToTerms: function(e) {
      e.preventDefault();
      EventBus.$emit("dismissAuth");
      if (this.$route.path != "/article/terms") {
        this.$router.push({
          name: "article",
          params: { alias: "terms" }
        });
      }
    }
  }
};
</script>